import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';
import {OEManualViewConfigFactory} from '../../views/manual-view/oe-manual-view-model';
import {OEFNHelpEntryType} from '../../views/flow-nav/help/oe-flow-nav-help-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import {OEImplantcastTargetType, OEImplantcastTargets, OEImplantcastFeatureAccess, OEImplantcastStartSelectionData, OEImplantcastManual} from './oe-implantcast-model';

export default class OEImplantcastStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEImplantcastTargetType.op, stringId: 'target_menu_op', icon: OEIconCodes.implantcast.opTarget},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEImplantcastTargetType.anatomy, stringId: 'target_menu_anatomy', icon: OEIconCodes.implantcast.anatomyTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note'},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEImplantcastTargetType.op, stringId: 'target_menu_op', icon: OEIconCodes.implantcast.opTarget},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEImplantcastTargetType.anatomy, stringId: 'target_menu_anatomy', icon: OEIconCodes.implantcast.anatomyTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.licensing},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note'},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];

        //
        let manualViewFactory = new OEManualViewConfigFactory();
        manualViewFactory.setLinks(OEImplantcastManual.getOpManualLinks());
        manualViewFactory.setVideoTutorialLink('implantcast_tutorial_video');

        this.manualViewLinksOp = manualViewFactory.config.links;

        //
        this.infoHelp = {
            entries: [
                {type: OEFNHelpEntryType.spacer, height: '4.125em' /*66*/},
                {type: OEFNHelpEntryType.text, stringId: 'info_help_view_text'},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
                {type: OEFNHelpEntryType.usageRights},
                {type: OEFNHelpEntryType.licenseAgreement, icon: '\uF0F6'},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/, mask: {licenseValid: true}},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/, mask: {licenseValid: false}},
                {type: OEFNHelpEntryType.text, stringId: 'info_help_view_no_license_text', mask: {licenseValid: false}},
                {type: OEFNHelpEntryType.spacer, height: '1.25em' /*20*/, mask: {licenseValid: false}},
                {type: OEFNHelpEntryType.email, icon: OEIconCodes.freePremiumView.email, stringId: 'info_help_view_email', linkId: 'info_help_view_email', spacerHeight: '1.25em', mask: {licenseValid: false}},
                {type: OEFNHelpEntryType.website, icon: OEIconCodes.freePremiumView.website, stringId: 'info_help_view_website_label', linkId: 'info_help_view_website', mask: {licenseValid: false}},
                {type: OEFNHelpEntryType.spacer, height: '1.25em' /*20*/, mask: {licenseValid: false}},
            ],
            version:        false,
            versionForDev:  false
        };
    }

    render()    {
        let {helpViewConfig, ...rest} = this.props;

        if(this.props.target === OETarget.effigosExplorerHelp)  {
            helpViewConfig = Object.assign({}, helpViewConfig);
            helpViewConfig.manualViewLinks = this.manualViewLinksOp;
        }

        return (
            <OEProtoStartView
                {...rest}
                entries={this.entries}
                helpViewConfig={helpViewConfig}
                infoHelp={this.infoHelp}
                versionTargets={OEImplantcastTargets}
                featureAccess={OEImplantcastFeatureAccess}
                startSelectionData={OEImplantcastStartSelectionData}
            />
        );
    }
}